import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";

// Voce di novità con eventuale "Provala ora" verso la pagina della funzione.
export function ReleaseItem({ item, testid, onTry }) {
  return (
    <li className="flex gap-2.5 text-sm text-forest" data-testid={testid}>
      <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-terracotta" />
      <span className="flex-1">
        {item.text}
        {item.link && (
          <Link to={item.link} onClick={onTry} data-testid={`${testid}-try`}
            className="ml-2 inline-flex items-center gap-1 whitespace-nowrap text-xs font-bold uppercase tracking-wide text-terracotta hover:text-terracotta-hover">
            Provala ora <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        )}
      </span>
    </li>
  );
}
